import { clsx } from "clsx";
import CropperModal from "components/molecules/imagecropper/CropperModal";
import { useState } from "react";

type Props = any;

function ProfileUpload({ id, setProfileImage, setImageErrors, imageErrors }: Props) {
  return (
    <label htmlFor={id} className="relative cursor-pointer">
      <span className="bg-secondary-btn rounded-full px-7 py-4 text-sm font-semibold text-primary opacity-80">
        UPLOAD
      </span>
      <input
        id={id}
        accept="image/png, image/jpeg"
        name={id}
        type="file"
        className="sr-only"
        onChange={(event: any) => {
          if (event.target.files[0]) {
            setProfileImage(event.target.files[0]);
            setImageErrors({
              ...imageErrors,
              isProfileErrors: false,
            });
          }
        }}
      />
    </label>
  );
}

export function ProfileUploadWithCustomOnChange({
  id,
  setFieldValue,
  labelClasses,
  showCropper,
  label, // remove when pencil button is required
}: {
  id: string;
  setFieldValue: (file: FileList) => void;
  labelClasses?: string;
  showCropper?: boolean;
  label: string; // not required for pencil icon
}) {
  const [image, setImage] = useState("");
  const [open, setOpen] = useState(false);
  const [format, setFormat] = useState("");
  const [cropperOpened, setCropperOpened] = useState(0);

  function handleSetImage(e: any) {
    if (e.target.files.length) {
      if (showCropper) {
        setCropperOpened(cropperOpened + 1);
        setOpen(true);
        setImage(URL.createObjectURL(e.target.files[0]));
        setFormat(e.target.files[0].type);
        // TODO: Add a comment here what this is doing?
        e.target.value = null;
      } else {
        setFieldValue(e.target.files);
      }
    }
  }

  return (
    <>
      {showCropper && (
        <CropperModal
          image={image}
          setImage={setFieldValue}
          open={open}
          setOpen={setOpen}
          format={format}
          key={cropperOpened}
        />
      )}
      <label htmlFor={id} className={clsx("relative flex cursor-pointer whitespace-nowrap", labelClasses)}>
        <span
          className="rounded-full bg-secondary px-7 py-4
      font-sora text-xxs font-semibold text-primary hover:opacity-80 "
        >
          {label}
        </span>
        <input id={id} accept="image/*" name={id} type="file" className="sr-only" onChange={handleSetImage} />
      </label>
      {/* <label
        htmlFor={id}
        className={clsx("r relative -right-16 -top-7 inline-block cursor-pointer rounded-full bg-secondary p-2.5")}
      >
        <span className=" text-primary">
          <PencilIcon className="h-6 w-6 fill-black" />         //uncomment when pencil icon needed
        </span>
        <input id={id} accept="image/*" name={id} type="file" className="sr-only" onChange={handleSetImage} />
      </label> */}
    </>
  );
}
export default ProfileUpload;
